<template>
  <div class="cover-corner media-large">
    <div class="layer media-container">
      <slot name="media"></slot>
    </div>

    <div class="layer content-container">
      <div class="content-box">
        <slot name="header"></slot>
        <slot name="jobCounter"></slot>
        <slot name="ctaButton"></slot>
        <slot name="search"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoverCorner",
};
</script>

<style lang="scss" scoped>
@import "../scss/shared";
@import "../scss/media-large";

.content-container {
  justify-content: flex-end;
  align-items: flex-start;

  @include laptop {
    align-items: flex-start;
  }
}

.content-box {
  text-align: left;
  position: absolute;

  width: 100%;

  padding: 128px;
  bottom: 144px;

  @include laptop {
    padding: 64px;
  }

  @include tablet {
    padding: 32px;
  }

  @include mobile {
    padding: 25px;
  }
}
</style>
